var map = {
	"./Cancel_public_events_delay.svg": "eWHR",
	"./Cancel_public_events_timeline.svg": "RMVX",
	"./International_travel_controls_delay.svg": "zeGX",
	"./International_travel_controls_timeline.svg": "719Q",
	"./Restrictions_on_gatherings_delay.svg": "+fN4",
	"./Restrictions_on_gatherings_timeline.svg": "Kn/R",
	"./Restrictions_on_internal_movement_delay.svg": "V7s9",
	"./Restrictions_on_internal_movement_timeline.svg": "wWQs",
	"./School_closing_delay.svg": "breP",
	"./School_closing_timeline.svg": "40F/",
	"./Stay_at_home_requirements_delay.svg": "zjZk",
	"./Stay_at_home_requirements_timeline.svg": "WKgP",
	"./Workplace_closing_delay.svg": "2zVq",
	"./Workplace_closing_timeline.svg": "yLhY",
	"./deaths.svg": "6S+K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r0m4";